import React from 'react';
import { isEmpty as _isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MainPopup = ({ content, onClose }) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="bg-[#F4F6FA] p-[40px] pt-[46px] pb-[70px] text-left  border-t-[3px] border-primary">
        <div className="text-[#803ad3] font-Pretendard text-[36px] font-bold mb-[30px]">
          {content.title}
        </div>
        <div className="font-Pretendard">
          {/* <img
                alt=""
                src={`${content.url}`}
                className="absolute object-cover object-center w-full h-full"
              /> */}
          {content.content}
        </div>
        <div className="mt-[23px] mb-[25px]">
          {content.imageSrc.split('/').length > 3 && (
            <img src={`${content.imageSrc}`} alt="notice popup" />
          )}
        </div>
        <div className="mt-[30px]">
          {!_isEmpty(content.url) && (
            <a
              href={`${content.url}`}
              target={content.moveType === 'Y' ? '_blank' : '_self'}
              onClick={onClose}
            >
              <button className="bg-[#803ad3] py-[17px] px-[20px] pr-[17px] text-white flex items-center gap-x-[8px] font-Pretendard font-bold text-[14px]">
                <span>{t('자세히 보기')}</span>
                <i className="icon-arrow-right-w text-[11px] inline-block"></i>
              </button>
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default MainPopup;
